import { Select } from '@bettercomp/ui-components';
import React from 'react';
import { OAuth2Form, OAuth2FormErrors } from './OAuth2';
import { Col, Row } from 'antd';
import { HRISAuth, HRISAuthProvider, OAuth2Auth } from 'types';

const authenticationOptions = [
  { label: 'OAuth', value: HRISAuthProvider.OAUTH2 },
]

export type AuthErrors = OAuth2FormErrors;

type AuthFormProps = {
  form?: HRISAuth,
  onChange: (data: HRISAuth) => void,
  disabled?: boolean,
  errors?: AuthErrors,
}


export const AuthForm = ({ form, onChange, errors }: AuthFormProps) => {

  const handleAuthProviderChange = (value: HRISAuthProvider) => {
    onChange({
      ...form,
      provider: value
    });
  }

  const handleDataChange = (data: OAuth2Auth) => {
    onChange({
      ...form,
      config: form?.config ? {
        ...form.config,
        ...data,
      } : data,
    });
  }

  return (
    <Row gutter={[12, 24]}>
      <Col xs={12}>
        <Select
          value={form?.provider}
          placeholder="Provider"
          options={authenticationOptions}
          onChange={handleAuthProviderChange}
          label="Authentication method"
          data-testid="Authentication method_Selector"
        />
      </Col>
      {form?.provider === HRISAuthProvider.OAUTH2 && (
        <OAuth2Form errors={errors} form={form.config || {}} onChange={handleDataChange} />
      )}
    </Row>
  )
}
